import React from "react";

/** Use to generate a unique ID within a functional component */
export const useUniqueId = (idPrefix: string, propId?: string) => {
  const reactId = React.useId();
  return propId ?? `${idPrefix}${reactId}`;
};
